import { UserRepository } from "../../repositories/UserRepository";

/**
 * Create User Use Case
 * Creates a new user and assigns to companies
 */
export class CreateUserUseCase {
  constructor(private repository: UserRepository) {}

  async execute(data: {
    email: string;
    password: string;
    userName?: string;
    company_ids?: number[];
    roles?: { [companyId: number]: string };
  }): Promise<{
    user: any;
    assigned_companies: any[];
  }> {
    if (!data.email || !data.email.trim()) {
      throw new Error("Email is required");
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      throw new Error("Invalid email format");
    }

    if (!data.password || data.password.length < 8) {
      throw new Error("Password must be at least 8 characters");
    }

    return await this.repository.createUser(data);
  }
}

